import { render, staticRenderFns } from "./Obligations.vue?vue&type=template&id=d37ffbc6"
import script from "./Obligations.vue?vue&type=script&lang=js"
export * from "./Obligations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports